/* eslint-disable camelcase */
import React from 'react';
import memoize from 'memoize-one';

import { ButtonTooltip, ApprovementStatus, Icon, ApproveRejectActions } from '../../../components';

const columns = memoize((clickHandler, ability) => [
  {
    name: 'FECHA DE SOLICITUD',
    selector: 'created_at',
    sortable: true,
    grow: '2'
  },
  {
    name: 'MONTO',
    selector: 'amount',
    cell: item => item.parsed_amount,
    sortable: true,
    grow: '1'
  },
  {
    name: 'INICIO',
    selector: 'start_date',
    sortable: true,
    grow: '1'
  },
  {
    name: 'TÉRMINO',
    selector: 'end_date',
    sortable: true,
    grow: '1'
  },
  {
    name: 'ESTADO',
    selector: 'status',
    cell: item => <ApprovementStatus status={item.status} onClick={() => clickHandler(item, 'show')} />,
    sortable: true,
    grow: '1'
  },
  {
    name: 'APROBAR',
    cell: item => (
      <ApproveRejectActions
        resource="AdvancePayment"
        item={item}
        clickHandler={clickHandler}
        approveText={item.request_reviewer_signature ? 'Firmar' : 'Aprobar'}
      />
    ),
    ignoreRowClick: true,
    allowOverflow: false,
    minWidth: '110px',
    grow: '0.5'
  },
  {
    name: 'ACCIONES',
    cell: item => (
      <>
        <ButtonTooltip
          variant="circle-info"
          className="btn-circle"
          onClick={() => clickHandler(item, 'show')}
          text="Ver"
        >
          <Icon icon="eye" />
        </ButtonTooltip>
        {ability.can('destroy', 'AdvancePayment') && (
          <ButtonTooltip
            variant="circle-danger"
            className="btn-circle"
            onClick={() => clickHandler(item, 'destroy')}
            disabled={item.status !== 'pending'}
            text="Eliminar"
          >
            <Icon icon="trash" />
          </ButtonTooltip>
        )}
      </>
    ),
    ignoreRowClick: true,
    allowOverflow: false,
    right: true,
    minWidth: '100px'
  }
]);

export default columns;
